var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 1083.954 1300.8585",
    width: 1083.954,
    height: 1300.8585,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1 {\n        font-family: NevanRUS, 'Nevan RUS';\n        font-size: 130px;\n      }\n      .cls-1, .cls-2 {\n        fill: #17e6e6;\n      }\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "846.5,892.93 625.56,1020.49 593.17,1001.79 183.67,765.37 183.67,745.14 183.67,663.32 183.67,459.22 183.67,357.17 183.67,255.12 404.6,127.56 625.56,0 979.06,204.1 1035.06,236.42 1067.43,255.12 1067.43,357.17 625.56,612.29 537.16,561.27 537.16,459.22 802.31,306.15 625.56,204.1 360.42,357.17 360.42,412.56 360.42,561.27 360.42,663.32 625.56,816.39 625.85,816.57 626.17,816.03 1067.43,561.27 1067.43,765.37 ",
    id: "polygon6",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    },
    transform: "translate(-85.631781)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "EyeVis-med.com",
    transform: "translate(-83.881781,1168.94)",
    id: "text10",
    className: "cls-1",
    style: {
      fontSize: 130,
      fontFamily: "NevanRUS, 'Nevan RUS'",
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g309",
    transform: "matrix(2.2070185,0,0,2.2070185,59.781139,128.76243)",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.44,-74.62 H 10.92 V -91 h 76.44 l -4.94,12.22 q -2.08,4.16 -5.98,4.16 z M 59.02,-37.57 H 10.92 V -53.43 H 69.68 L 65,-41.73 q -2.08,4.16 -5.98,4.16 z M 76.83,0 H 10.92 V -16.38 H 87.36 L 82.94,-4.29 Q 80.99,0 76.83,0 Z",
    id: "path296",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 150.53987,0 h -18.85 v -35.36 l 32.89,-50.83 q 3.38,-4.81 8.84,-4.81 h 14.82 l -37.7,56.81 z m -22.75,-41.34 L 94.899873,-91 h 15.989997 q 5.46,0 8.84,4.81 l 18.46,28.73 z",
    id: "path298",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 265.45981,-74.62 h -65.52 V -91 h 76.44 l -4.94,12.22 q -2.08,4.16 -5.98,4.16 z m -17.42,37.05 h -48.1 v -15.86 h 58.76 l -4.68,11.7 q -2.08,4.16 -5.98,4.16 z m 17.81,37.57 h -65.91 v -16.38 h 76.44 l -4.42,12.09 q -1.95,4.29 -6.11,4.29 z",
    id: "path300",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 342.67968,0 37.44,-91 h -12.48 q -6.24,0 -9.62,6.63 l -25.87,65.26 -27.82,-71.89 h -20.41 l 34.32,84.5 q 3.25,6.5 9.62,6.5 z",
    id: "path302",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 410.01954,0 v -84.5 q 0,-2.73 -1.95,-4.55 -1.82,-1.95 -4.55,-1.95 h -12.35 V 0 Z",
    id: "path304",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 463.70949,1.43 q -11.44,0 -21.97,-4.29 -10.4,-4.29 -18.33,-11.44 l 8.19,-8.19 q 2.21,-1.95 4.55,-1.95 1.95,0 3.9,1.17 11.96,8.71 24.96,8.71 8.32,0 13.39,-2.99 5.2,-3.12 5.2,-8.45 0,-4.81 -3.64,-7.41 -3.51,-2.6 -11.31,-3.77 l -18.07,-3.12 q -12.09,-2.08 -17.94,-8.45 -5.85,-6.37 -5.85,-15.86 0,-13.13 9.88,-20.28 9.88,-7.28 26,-7.28 9.49,0 19.5,3.25 10.01,3.25 18.07,9.49 l -8.71,8.71 q -1.82,1.82 -4.55,1.82 -1.69,0 -3.38,-0.91 -10.92,-6.5 -22.23,-6.5 -7.28,0 -11.96,2.73 -4.68,2.6 -4.68,7.54 0,4.29 3.12,6.63 3.12,2.34 9.88,3.25 l 17.16,2.86 q 27.17,4.29 27.17,25.61 0,13.52 -10.66,21.32 -10.53,7.8 -27.69,7.8 z",
    id: "path306",
    style: {
      fill: "#6be3e4",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fd372b8bc11d36ee958a63852f40914.svg";
export { ForwardRef as ReactComponent };